import { Moment } from 'moment';
import { DateUtils } from '../../utils/DateUtils';
import { GQLIdEncoder } from '../../utils/GQLIdEncoder';
import { KeyCertificate } from '../models/KeyCertificate';

export class KeyCertificateMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): KeyCertificate {
    let expiryDate: Moment | null = null;
    if (data.notAfter) {
      expiryDate = DateUtils.toMoment(data.notAfter);
    }

    return new KeyCertificate(this.gqlIdEncoder.decode(data.id), data.subject, data.issuer, data.signatureAlgorithm.digest, expiryDate);
  }
}
